module.exports = __webpack_public_path__ + "img/archway_k_b1.b0f648b1.jpg";